var _defineProperty = require("/opt/build/repo/client/node_modules/@babel/runtime/helpers/defineProperty.js");

var _formatPlaceholdersMa;

require("core-js/modules/es.string.trim-end.js");

var ASTERISK_ITALIC = "*",
    UNDERSCORE_ITALIC = "_",
    ASTERISK_BOLD = "**",
    UNDERSCORE_BOLD = "__",
    ESCAPED_UNDERSCORE = "\\_",
    ESCAPED_ASTERISK = "\\*",
    ESCAPED_ASTERISK_REGEXP = /\\\*/g,
    ASTERISK_PLACEHOLDER_REGEXP = /ASTERISKPLACEHOLDER/gm,
    ESCAPED_UNDERSCORE_REGEXP = /\\_/g,
    UNDERSCORE_PLACEHOLDER_REGEXP = /UNDERSCOREPLACEHOLDER/gm,
    UNDERSCORE_BOLD_PLACEHOLDER_REGEXP = /UNDERSCOREBOLDPLACEHOLDER/gm,
    UNDERSCORE_BOLD_REGEXP = /(__)(.*?)(__)/g,
    ASTERISK_BOLD_PLACEHOLDER_REGEXP = /ASTERISKBOLDPLACEHOLDER/gm,
    ASTERISK_BOLD_REGEXP = /(\*\*)(.*?)(\*\*)/g,
    UNDERSCORE_ITALIC_PLACEHOLDER_REGEXP = /UNDERSCOREITALICPLACEHOLDER/gm,
    UNDERSCORE_ITALIC_REGEXP = /(_)(.*?)(_)/g,
    ASTERISK_ITALIC_PLACEHOLDER_REGEXP = /ASTERISKITALICPLACEHOLDER/gm,
    ASTERISK_ITALIC_REGEXP = /(\*)(.*?)(\*)/g,
    HYPERLINK = /^\[([^[]+)\]\(([^)]+)\)/,
    replaceFormatMarkersWithPlaceholders = function replaceFormatMarkersWithPlaceholders(t) {
  return t.replace(ESCAPED_UNDERSCORE_REGEXP, UNDERSCORE_PLACEHOLDER_REGEXP.source).replace(ESCAPED_ASTERISK_REGEXP, ASTERISK_PLACEHOLDER_REGEXP.source).replace(UNDERSCORE_BOLD_REGEXP, "".concat(UNDERSCORE_BOLD_PLACEHOLDER_REGEXP.source, "$2").concat(UNDERSCORE_BOLD_PLACEHOLDER_REGEXP.source)).replace(ASTERISK_BOLD_REGEXP, "".concat(ASTERISK_BOLD_PLACEHOLDER_REGEXP.source, "$2").concat(ASTERISK_BOLD_PLACEHOLDER_REGEXP.source)).replace(UNDERSCORE_ITALIC_REGEXP, "".concat(UNDERSCORE_ITALIC_PLACEHOLDER_REGEXP.source, "$2").concat(UNDERSCORE_ITALIC_PLACEHOLDER_REGEXP.source)).replace(ASTERISK_ITALIC_REGEXP, "".concat(ASTERISK_ITALIC_PLACEHOLDER_REGEXP.source, "$2").concat(ASTERISK_ITALIC_PLACEHOLDER_REGEXP.source));
},
    replaceFormatPlaceholdersWithMarkers = function replaceFormatPlaceholdersWithMarkers(t) {
  return t.replace(UNDERSCORE_PLACEHOLDER_REGEXP, ESCAPED_UNDERSCORE).replace(ASTERISK_PLACEHOLDER_REGEXP, ESCAPED_ASTERISK).replace(UNDERSCORE_BOLD_PLACEHOLDER_REGEXP, UNDERSCORE_BOLD).replace(ASTERISK_BOLD_PLACEHOLDER_REGEXP, ASTERISK_BOLD).replace(UNDERSCORE_ITALIC_PLACEHOLDER_REGEXP, UNDERSCORE_ITALIC).replace(ASTERISK_ITALIC_PLACEHOLDER_REGEXP, ASTERISK_ITALIC);
},
    formatMarkers = [ASTERISK_BOLD_PLACEHOLDER_REGEXP.source, UNDERSCORE_BOLD_PLACEHOLDER_REGEXP.source, ASTERISK_ITALIC_PLACEHOLDER_REGEXP.source, UNDERSCORE_ITALIC_PLACEHOLDER_REGEXP.source],
    formatPlaceholdersMap = (_formatPlaceholdersMa = {}, _defineProperty(_formatPlaceholdersMa, UNDERSCORE_PLACEHOLDER_REGEXP.source, ESCAPED_UNDERSCORE.length), _defineProperty(_formatPlaceholdersMa, ASTERISK_PLACEHOLDER_REGEXP.source, ESCAPED_ASTERISK.length), _formatPlaceholdersMa),
    findFormatPlaceholderAhead = function findFormatPlaceholderAhead(t) {
  var E = Object.keys(formatPlaceholdersMap);

  for (var e = 0, r = E.length; e < r; e++) {
    if (t.startsWith(E[e])) return E[e];
  }

  return null;
},
    findFormatMarkerAhead = function findFormatMarkerAhead(t, E) {
  for (var e = 0, r = formatMarkers.length; e < r; e++) {
    if (t.startsWith(formatMarkers[e])) return E[E.length - 1] === formatMarkers[e] ? E.pop() : E.push(formatMarkers[e]), formatMarkers[e];
  }

  return null;
},
    truncate = function truncate(t, E, e) {
  var r = 0;

  var s = function s(o) {
    var L = [],
        l = !1,
        c = "",
        n = 0;

    for (; r < E && n < o.length;) {
      var u = findFormatMarkerAhead(o.substring(n), L);
      u && (c += u, n += u.length, l = !0);

      var _ = findFormatPlaceholderAhead(o.substring(n));

      _ && (c += _, n += _.length, l = !0, r += formatPlaceholdersMap[_]);
      var A = new RegExp(HYPERLINK),
          R = A.exec(o.substring(n));

      if (R) {
        var S = R[1],
            i = R[2];
        c += "[".concat(s(S), "](").concat(i, ")"), n += R[0].length, l = !0;
      }

      !u && !R && (c += o[n], n++), l || r++, l = !1;
    }

    for (c = c.trimEnd(); L.length > 0;) {
      c += L.pop();
    }

    return c;
  };

  var a = s(t);
  return e && a.length < t.length && (a += "..."), a;
};

module.exports = function () {
  var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var E = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = E || {},
      e = _ref.limit,
      r = _ref.ellipsis;

  if (isNaN(parseInt(e, 10)) || t.length <= e) return t;
  var s = replaceFormatMarkersWithPlaceholders(t);
  return s = truncate(s, e, r), s = replaceFormatPlaceholdersWithMarkers(s), s;
};